<template>
    <div>
        <el-container class="mainInfo" v-loading="mainLoading">
            <el-main>
                    <toolBar :loading.sync="mainLoading"
                             :menuId="menu_id"
                             :searchData="searchData"
                             @search="search"
                             @excel="excel">
                    </toolBar>
                    <tableGrid ref="tableGrid"
                               :sumObject="sumObject"
                               :showSummary="showSummary"
                               adaptiveHeight="123"
                               :headList="headList"
                               :dataList="dataList"
                               :pageInfo="pageInfo"
                               @tableOpt="tableOpt"
                               @toPage="toPage"
                               :loading="loading">
                    </tableGrid>
            </el-main>
        </el-container>
    </div>
</template>

<script>
    import toolBar from '@/components/page/finance/accountbook/toolBar'
    import tableGrid from '@/components/tools/table'

    export default {
        name: "liabilities",
        props: ['menuData'],
        components: {tableGrid, toolBar},
        data() {
            return {
                showSummary:true,
                sumObject: {},
                mainLoading: false,
                menu_id: this.menuData.menuId,
                searchData: {
                    formData:{}
                },

                width: "350px",
                dialogLoading: false,
                formData: {},
                tableH: 100,
                dataList: [],
                loading: false,
                headList: [
                    {
                        column_name: "_px", column_comment: "序号", column_width: "70"
                    },
                    {
                        column_name: "billNo", column_comment: "凭证编号", column_width: "150"
                    },
                    {
                        column_name: "billDate", column_comment: "凭证日期", column_width: "150"
                    },
                    {
                        column_name: "summary", column_comment: "摘要", column_width: "250"
                    },
                    {
                        column_name: "accTitleName", column_comment: "会计科目", column_width: "200"
                    },
                    {
                        column_name: "accTitleKind", column_comment: "科目标识", column_width: "100"
                    },
                    {
                        column_name: "debitTotal", column_comment: "借方金额", column_width: "150"
                    },
                    {
                        column_name: "creditTotal", column_comment: "贷方金额", column_width: "150"
                    },
                    {
                        column_name: "remainTotal", column_comment: "余额", column_width: "150"
                    }
                ],
                pageInfo: {
                    page: 1,
                    pagesize: 20,
                    pageSizes: [10, 20, 50, 100],
                    total: 0,
                }
            }
        },
        mounted() {
            //this.getListData();
        },
        methods: {
            async getListData() {
                if((this.searchData.formData.startMonth==null || this.searchData.formData.startMonth=='')
                    && (this.searchData.formData.endMonth==null || this.searchData.formData.endMonth=='')){
                    this.$message({message: '请选择统计月份范围', type: 'error'});
                    return false;
                }

                if(this.searchData.formData.accTitleName==null || this.searchData.formData.accTitleName==''){
                    this.$message({message: '请选择统计会计科目', type: 'error'});
                    return false;
                }

                this.loading = true;
                let param = {
                    url: "/financestatistics/listAccountBook",
                    param: {
                        ...this.searchData.formData,
                        limit: this.pageInfo.pagesize,
                        page: this.pageInfo.page
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param)
                if (data.infoCode == "0") {
                    this.dataList = data.data.jsonObject.data;
                    this.sumObject = data.data.sumObject;
                    this.pageInfo.total = data.data.jsonObject.count;
                }
                this.loading = false;
            },

            toPage() {
                this.getListData();
            },
            search(data) {
                this.searchData.formData = data;
                this.pageInfo.page = 1;
                this.getListData();
            },
            excel(data) {
                if((this.searchData.formData.startMonth==null || this.searchData.formData.startMonth=='')
                    && (this.searchData.formData.endMonth==null || this.searchData.formData.endMonth=='')){
                    this.$message({message: '请选择统计月份范围', type: 'error'});
                    return false;
                }

                if(this.searchData.formData.accTitleName==null || this.searchData.formData.accTitleName==''){
                    this.$message({message: '请选择统计会计科目', type: 'error'});
                    return false;
                }
                this.searchData.formData = data;

                let param = {
                    url: "/financestatistics/excelAccountBook",
                    param: {
                        ...this.searchData.formData
                    }
                }
                this.$pub.openPostWindow(param);
            },
            cellStyle() {
                return "text-align:center"
            },
            tableOpt() {
            },
        }
    }
</script>

